class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      this.input.addEventListener('input', this.onChange.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      //this.input.addEventListener('focusout', this.onFocusOut.bind(this));
  
      document.addEventListener("mouseup", (e) => {
        let searchResults = document.querySelector("#predictive-search-results");
        try{
          if (searchResults && !searchResults.contains(e.target) && !this.input.contains(e.target)) {
            this.input.addEventListener('input', this.onChange.bind(this));
            this.input.addEventListener("focus", this.onFocusOut(this));
          }
        } catch(e) {
          console.log(e);
        }
      });
    }
  
    onFocus() {
        const header = document.querySelector('.hd-Header');
        this.open();
        header.classList.add('header-focused');
    }
  
    onFocusOut() {
        const header = document.querySelector('.hd-Header');
        this.close();
        header.classList.remove('header-focused');
        this.input.value = '';
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'block';
    }
  
    close() {
      this.predictiveSearchResults.style.display = 'none';
    }
  }
  customElements.define('predictive-search', PredictiveSearch);